export const employees = {
  title_prefix: "Personal för ",
  health_title_prefix: "Personal för ",
  subtitle:
    "Hantera personal-ID:n som tilldelats denna organisation. Du kan skapa, redigera eller ta bort personalinformation vid behov.",
  health_subtitle:
    "Hantera personal-ID:n som tilldelats detta boende. Du kan skapa, redigera eller ta bort personalinformation vid behov.",
  empty_state_message:
    "Lägg till personal-ID:n för att börja hantera individer inom denna organisation.",
  health_empty_state_message:
    "Lägg till personal-ID:n för att börja hantera individer inom detta boende.",
  add_title_prefix: "Lägg till personal för ",
  health_add_title_prefix: "Lägg till personal för ",
  id_label: "ID",
  placeholder_id: "Skriv ID här...",

  // Edit Employee Screen
  edit_title_prefix: "Redigera personuppgifter för ",
  edit_subtitle:
    "Uppdatera personlig ID-information eller ta bort den om den inte längre behövs.",
  create_title_prefix: "Skapa anställd för ",
  create_subtitle: "Lägg till en ny anställd till denna organisation.",
  basic_information: "Grundläggande information",

  // Form labels
  email_label: "E-post",
  first_name_label: "Förnamn",
  last_name_label: "Efternamn",
  nickname_label: "Smeknamn",
  date_of_birth_label: "Födelsedatum",
  gender_label: "Kön",
  phone_number_label: "Telefonnummer",
  location_label: "Plats",
  settings_locked_label: "Inställningar låsta",

  // Placeholders
  placeholder_email: "Skriv e-post här...",
  placeholder_first_name: "Skriv förnamn här...",
  placeholder_last_name: "Skriv efternamn här...",
  placeholder_nickname: "Skriv smeknamn här...",
  placeholder_date_of_birth: "ÅÅÅÅ-MM-DD",
  placeholder_gender: "Skriv kön här...",
  placeholder_phone_number: "Skriv telefonnummer här...",
  placeholder_location: "Skriv plats här...",

  // Gender options
  gender_male: "Man",
  gender_female: "Kvinna",
  gender_prefer_not_to_say: "Vill inte ange",
};
